import { render, staticRenderFns } from "./foots.vue?vue&type=template&id=5c4691b8&scoped=true"
import script from "./foots.vue?vue&type=script&lang=js"
export * from "./foots.vue?vue&type=script&lang=js"
import style0 from "./foots.vue?vue&type=style&index=0&id=5c4691b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4691b8",
  null
  
)

export default component.exports